export const GOOGLE_CLIENT_ID = '302355290180-vj5a1dr349v7t0rfn2lv87lkb2b38ubm.apps.googleusercontent.com';
export const APP_ID = `${process.env.REACT_APP_NAME}-${process.env.REACT_APP_VERSION}`;
